// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import magicWand02Icon from "@/assets/icons/magic-wand-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MagicWand02IconProps = Omit<IconProps, "name">;

export function MagicWand02Icon(props: MagicWand02IconProps): React.ReactNode {
  return <Icon name={magicWand02Icon} {...props} />;
}
